<template>
  <div v-if="hasInfo" class="vacancy-department-info">
    <div class="vacancy-department-info__header">
      <p class="vacancy-department-info__title text-TTDrugs-bold-20 color-green">{{ blockHeading }}</p>
      <p v-if="departmentInfo.title" class="vacancy-department-info__subtitle text-circe-16 color-gray">
        {{ departmentInfo.title }}
      </p>
      <p v-if="departmentInfo.headOfDepartment" class="vacancy-department-info__meta text-circe-16 color-gray">
        Заведующий: {{ departmentInfo.headOfDepartment }}
      </p>
      <p v-if="departmentInfo.seniorNurse" class="vacancy-department-info__meta text-circe-16 color-gray">
        Старшая м/с: {{ departmentInfo.seniorNurse }}
      </p>
    </div>

    <div class="vacancy-department-info__cards">
      <div v-if="departmentInfo.address" class="vacancy-department-info__card">
        <div class="vacancy-department-info__card-icon">
          <img src="@/assets/svg/location.svg" alt="" />
        </div>
        <p class="vacancy-department-info__card-title text-circe-bold-18 color-green">Адрес отделения</p>
        <p class="vacancy-department-info__card-text text-circe-16 color-gray">{{ departmentInfo.address }}</p>
      </div>

      <div v-if="departmentInfo.contacts" class="vacancy-department-info__card">
        <div class="vacancy-department-info__card-icon">
          <img src="@/assets/svg/phone.svg" alt="" />
        </div>
        <p class="vacancy-department-info__card-title text-circe-bold-18 color-green">Контакты</p>
        <p
          v-for="(line, index) in splitLines(departmentInfo.contacts)"
          :key="`contact-${index}`"
          class="vacancy-department-info__card-text text-circe-16 color-gray"
        >
          {{ line }}
        </p>
      </div>

      <div v-if="departmentInfo.workingHours" class="vacancy-department-info__card">
        <div class="vacancy-department-info__card-icon">
          <span class="vacancy-department-info__clock" aria-hidden="true">🕒</span>
        </div>
        <p class="vacancy-department-info__card-title text-circe-bold-18 color-green">Режим работы</p>
        <p
          v-for="(line, index) in splitLines(departmentInfo.workingHours)"
          :key="`hours-${index}`"
          class="vacancy-department-info__card-text text-circe-16 color-gray"
        >
          {{ line }}
        </p>
      </div>

      <div v-if="departmentInfo.composition" class="vacancy-department-info__card">
        <div class="vacancy-department-info__card-icon">
          <img src="@/assets/svg/profile.svg" alt="" />
        </div>
        <p class="vacancy-department-info__card-title text-circe-bold-18 color-green">Состав отделения</p>
        <p
          v-for="(line, index) in splitLines(departmentInfo.composition)"
          :key="`composition-${index}`"
          class="vacancy-department-info__card-text text-circe-16 color-gray"
        >
          {{ line }}
        </p>
      </div>
    </div>

    <p class="vacancy-department-info__note text-circe-14 color-gray">
      Данные соответствуют внутреннему регламенту центра и обновляются ответственным сотрудником.
    </p>
  </div>
</template>

<script>
export default {
  name: "AppVacancyDepartmentInfo",
  props: {
    departmentInfo: {
      type: Object,
      default() {
        return null;
      },
    },
    heading: {
      type: String,
      default: "",
    },
  },
  computed: {
    blockHeading() {
      return String(this.heading || "").trim() || "Информация об отделении";
    },
    hasInfo() {
      if (!this.departmentInfo) {
        return false;
      }

      return [
        this.departmentInfo.title,
        this.departmentInfo.headOfDepartment,
        this.departmentInfo.seniorNurse,
        this.departmentInfo.address,
        this.departmentInfo.contacts,
        this.departmentInfo.workingHours,
        this.departmentInfo.composition,
      ].some((value) => String(value || "").trim() !== "");
    },
  },
  methods: {
    splitLines(value) {
      return String(value || "")
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean);
    },
  },
};
</script>
